import { useState } from "react"
import { SignupFormImport } from "./Import"
const { Button, Card, Form, Text, SelectBox, DatePicker, Number, Email, Password, File, useFormik, ButtonLoader, logo, UserSignupSchema, useDispatch, useNavigate, signUp, addUpdateHandler, useTranslation } = SignupFormImport

export default function UserSignupForm(props) {

    const { setTogggle } = props

    const [spinner, setSpinner] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [confirmPassword, setConfirmPassword] = useState(false)
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const gender_option = [
        { "value": 'male', "label": 'Male' },
        { "value": 'female', "label": 'Female' },
        { "value": 'other', "label": 'Other' },
    ]

    const initialValues = {
        first_name: '',
        last_name: '',
        gender: '',
        dob: '',
        email: '',
        password: '',
        confirm_password: '',
        mobile_number: '',
        profile: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, setFieldTouched } = useFormik({
        initialValues: initialValues,
        validationSchema: UserSignupSchema,

        onSubmit: (values, action) => {
            // console.log(values)
            setSpinner(true)
            dispatch(signUp({ 'values': values })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: "Sign-up successful! You can now log in with the credentials you created.",
                wrong_toast: `${t('common.wrong')}`,
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    setTogggle(false);
                }
            }))
        },
    })

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100'>
                <Card className="h-100 rounded-start-5 rounded-end-0" style={{ backgroundColor: '#F8FAFC' }}>
                    <Card.Header className="p-3 text-end" style={{ backgroundColor: 'unset' }}>
                        <span className='fs-6 text-muted'>Already have an account?
                            <u className='fw-medium green' style={{ cursor: 'pointer' }} onClick={() => setTogggle(false)}> Login</u>
                        </span>
                    </Card.Header>
                    <Card.Body className='px-4 py-2 d-flex align-items-center'>
                        <div className='flex-fill'>
                            <img src={logo} alt="logo" className='img-fluid' style={{ height: '100px' }} />
                            <div className='mt-3'>
                                <h3 className='green'>Sign Up to Continue</h3>
                                <p>Let's get started !!...</p>
                            </div>

                            <div className="row">

                                <div className="col-md-4">
                                    <Text
                                        label_name={t('customer.fname')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='first_name'
                                        value={values.first_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.first_name && touched.first_name ? (<span className='field_error'>{errors.first_name}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <Text
                                        label_name={t('customer.lname')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='last_name'
                                        value={values.last_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.last_name && touched.last_name ? (<span className='field_error'>{errors.last_name}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <DatePicker
                                        label_name={t('customer.dob')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='dob'
                                        value={values.dob || ''}
                                        onChange={(date, dateString) =>
                                            setFieldValue('dob', dateString)
                                        }
                                        onBlur={() => setFieldTouched("dob", true)}
                                        error={errors.dob && touched.dob ? (<span className='field_error'>{errors.dob}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <SelectBox
                                        label_name={t('customer.gender')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        option={gender_option}
                                        name='gender'
                                        value={values.gender}
                                        onChange={(e) =>
                                            setFieldValue('gender', e)
                                        }
                                        onBlur={() => setFieldTouched("gender", true)}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        error={errors.gender && touched.gender ? (<span className='field_error'>{errors.gender}</span>) : null}
                                    />
                                </div>

                                <div className='col-md-4'>
                                    <Number
                                        label_name={t('customer.mobile')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='mobile_number'
                                        value={values.mobile_number}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.mobile_number && touched.mobile_number ? (<span className='field_error'>{errors.mobile_number}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Password
                                        label_name={t('customer.password')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='password'
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.password && touched.password ? (<span className='field_error'>{errors.password}</span>) : null}
                                        showPassword={showPassword}
                                        setShowPassword={setShowPassword}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Password
                                        label_name={t('customer.confirm_password')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='confirm_password'
                                        value={values.confirm_password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.confirm_password && touched.confirm_password ? (<span className='field_error'>{errors.confirm_password}</span>) : null}
                                        showPassword={confirmPassword}
                                        setShowPassword={setConfirmPassword}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Email
                                        label_name={t('customer.email')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='email'
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.email && touched.email ? (<span className='field_error'>{errors.email}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <File
                                        label_name={t('customer.profile')}
                                        mandatory={false}
                                        disabled={false}
                                        name='profile'
                                        onChange={(e) =>
                                            setFieldValue('profile', e.currentTarget.files[0])
                                        }
                                        onBlur={handleBlur}
                                        error={errors.profile && touched.profile ? (<span className='field_error'>{errors.profile}</span>) : null}
                                        accept="image/jpg, image/jpeg, image/png"
                                    />
                                </div>

                            </div>

                        </div>
                    </Card.Body>
                    <Card.Footer className="text-muted d-flex justify-content-between align-items-center" style={{ backgroundColor: 'unset' }}>
                        <span style={{ fontSize: '13px' }} className=''>By continuing, you agree to the <u className='green' style={{ cursor: 'pointer' }}>terms of service</u> and <u className='green' style={{ cursor: 'pointer' }}>privacy policy</u>.</span>
                        <Button type='submit' size='sm' className='login_save_btn' disabled={spinner}>
                            {spinner ?
                                <ButtonLoader />
                                :
                                'Sign up'
                            }
                        </Button>
                    </Card.Footer>
                </Card>
            </Form>
        </>
    )
}
